import React from 'react';
import { motion } from 'framer-motion';
import { PartnerPortalLayout } from './PartnerPortalLayout';
import { SparklesIcon, TargetIcon } from 'lucide-react';
export function PipelinePage() {
  const columns = [{
    id: 'eligible',
    title: 'Eligible',
    value: '$135,000',
    count: 3,
    cards: [{
      client: 'Finova Capital',
      event: 'Annual Leadership Summit',
      fit: 98,
      sku: 'AI Leadership Retreat',
      value: '$45,000',
      conf: 'HIGH CONF.'
    }, {
      client: 'Aurora Consumer',
      event: 'Innovation Week',
      fit: 82,
      sku: 'AI Leadership Retreat',
      value: '$55,000',
      conf: 'MED CONF.'
    }, {
      client: 'Global Logistics',
      event: 'Sales Kickoff',
      fit: 75,
      sku: 'Custom Wellness Track',
      value: '$35,000',
      conf: 'LOW CONF.'
    }]
  }, {
    id: 'identified',
    title: 'Upsell Identified',
    value: '$0',
    count: 0,
    cards: []
  }, {
    id: 'proposal',
    title: 'Proposal Sent',
    value: '$28,000',
    count: 1,
    cards: [{
      client: 'NorthBridge Tech',
      event: 'Q4 Strategy Offsite',
      fit: 92,
      sku: 'Executive Alignment Retreat',
      value: '$28,000',
      conf: 'MEDIUM CONF.'
    }]
  }, {
    id: 'discussion',
    title: 'In Discussion',
    value: '$25,000',
    count: 1,
    cards: [{
      client: 'Helix Health',
      event: 'Post-Merger Integration',
      fit: 95,
      sku: 'Executive Alignment Retreat',
      value: '$25,000',
      conf: 'HIGH CONF.'
    }]
  }, {
    id: 'won',
    title: 'Closed-Won',
    value: '$850,000',
    count: 4,
    cards: []
  }];
  return <PartnerPortalLayout data-id="element-5116">
      <div className="p-6 lg:p-10 max-w-[1600px] mx-auto h-[calc(100vh-4rem)] flex flex-col" data-id="element-5117">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-8 shrink-0" data-id="element-5118">
          <h1 className="font-serif-display text-3xl md:text-4xl font-bold text-[#0B1B3B] mb-2" data-id="element-5119">
            Revenue Pipeline
          </h1>
          <p className="text-slate-500" data-id="element-5120">
            Track your retreat upsell opportunities from identification to
            closed-won.
          </p>
        </motion.div>

        <div className="flex-1 overflow-x-auto pb-4" data-id="element-5121">
          <div className="flex gap-6 h-full min-w-max" data-id="element-5122">
            {columns.map((col, i) => <motion.div key={col.id} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1
          }} className="w-80 flex flex-col bg-slate-50/50 rounded-xl border border-slate-200" data-id="element-5123">
                <div className="p-4 border-b border-slate-200 bg-slate-50 rounded-t-xl shrink-0" data-id="element-5124">
                  <div className="flex items-center justify-between mb-1" data-id="element-5125">
                    <h2 className="font-bold text-[#0B1B3B]" data-id="element-5126">{col.title}</h2>
                    <span className="text-xs font-bold text-slate-500 bg-white border border-slate-200 px-2 py-0.5 rounded-full" data-id="element-5127">
                      {col.count}
                    </span>
                  </div>
                  <div className="text-sm font-bold text-emerald-600" data-id="element-5128">
                    {col.value}
                  </div>
                </div>

                <div className="p-3 flex-1 overflow-y-auto space-y-3" data-id="element-5129">
                  {col.cards.length > 0 ? col.cards.map((card, j) => <div key={j} className="bg-white p-4 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer" data-id="element-5130">
                        <div className="flex items-start justify-between mb-1" data-id="element-5131">
                          <h3 className="font-serif-display text-lg font-bold text-[#0B1B3B] leading-tight" data-id="element-5132">
                            {card.client}
                          </h3>
                          <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${card.fit >= 90 ? 'bg-emerald-100 text-emerald-700' : card.fit >= 80 ? 'bg-amber-100 text-amber-700' : 'bg-slate-100 text-slate-600'}`} data-id="element-5133">
                            {card.fit} Fit
                          </span>
                        </div>
                        <div className="text-xs text-slate-500 mb-3" data-id="element-5134">
                          {card.event}
                        </div>

                        <div className="inline-flex items-center gap-1.5 px-2 py-1 bg-slate-50 border border-slate-100 rounded text-[10px] font-bold text-slate-600 uppercase tracking-wider mb-4 w-full" data-id="element-5135">
                          {card.sku.includes('AI') ? <SparklesIcon className="w-3 h-3 text-amber-500" data-id="element-5136" /> : <TargetIcon className="w-3 h-3 text-amber-500" data-id="element-5137" />}
                          <span className="truncate" data-id="element-5138">{card.sku}</span>
                        </div>

                        <div className="flex items-center justify-between" data-id="element-5139">
                          <span className="font-bold text-emerald-600" data-id="element-5140">
                            {card.value}
                          </span>
                          <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wider" data-id="element-5141">
                            {card.conf}
                          </span>
                        </div>
                      </div>) : <div className="h-24 border-2 border-dashed border-slate-200 rounded-lg flex items-center justify-center text-sm text-slate-400 font-medium" data-id="element-5142">
                      No opportunities
                    </div>}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </PartnerPortalLayout>;
}